import React, { useCallback, useEffect, useState } from 'react';
import { adminApi } from '../../api/admin/adminApi';

function formatWhen(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString();
}

export default function PlanWaitlistPanel() {
  const [plan, setPlan] = useState('');
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async (nextPlan = plan) => {
    setLoading(true);
    setError('');
    try {
      const result = await adminApi.listPlanWaitlist(nextPlan ? { plan: nextPlan } : {});
      setEntries(Array.isArray(result?.entries) ? result.entries : []);
    } catch {
      setEntries([]);
      setError("Couldn't load the waitlist. Try again.");
    } finally {
      setLoading(false);
    }
  }, [plan]);

  useEffect(() => {
    load(plan);
  }, [load, plan]);

  return (
    <div className="analytics-section" style={{ marginTop: 24 }}>
      <div className="admin-table-header">
        <div>
          <h2>Plan waitlists</h2>
          <p className="admin-table-subtitle">Pro and Teams interest. Joining does not start a subscription.</p>
        </div>
        <div className="admin-table-actions">
          <button type="button" className="btn" onClick={() => load(plan)} disabled={loading}>
            Refresh
          </button>
        </div>
      </div>

      <div className="admin-table-filters">
        <label>
          Plan{' '}
          <select
            aria-label="Filter waitlist by plan"
            value={plan}
            onChange={(event) => setPlan(event.target.value)}
          >
            <option value="">All</option>
            <option value="pro">Pro</option>
            <option value="teams">Teams</option>
          </select>
        </label>
      </div>

      {error ? (
        <p className="error" role="alert">
          {error}{' '}
          <button type="button" className="btn" onClick={() => load(plan)}>
            Try again
          </button>
        </p>
      ) : null}

      {loading ? <p>Loading waitlist…</p> : null}

      {!loading && !error && entries.length === 0 ? <p>No one has joined this waitlist yet.</p> : null}

      {!loading && !error && entries.length > 0 ? (
        <div className="admin-table">
          <table>
            <thead>
              <tr>
                <th>Plan</th>
                <th>Email</th>
                <th>Joined</th>
                <th>Account</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((entry) => (
                <tr key={entry.id}>
                  <td>{entry.plan === 'teams' ? 'Teams' : 'Pro'}</td>
                  <td>{entry.email}</td>
                  <td>{formatWhen(entry.createdAt)}</td>
                  <td>{entry.userId || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
